$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  modifySignup();
});

$(window).load(function () {
  contentMarginTop();
});

$(window).resize(function () {
  contentMarginTop();
});

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

// Customize Sign Up
function modifySignup() {
  const signupWidget = $('.emailSignup');
  const inputField = signupWidget.find('.emailInputField');
  const submitButton = signupWidget.find('.emailInputSubmit');
  signupWidget.find('.emailSignupText').replaceWith(`
    <div class="emailSignupTextContainer">       
      <h3>Join Our Email Newsletter</h3>     
    </div>`);
  $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');
  inputField
    .find('.inputFieldTextbox')
    .val('')
    .attr('placeholder', 'Enter Email Address')
    .attr('aria-label', 'Enter Email Address');
  submitButton
    .find('.emailSubmitButton')
    .text('Subscribe')
    .addClass('button-outline')
    .removeClass('button');
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header').outerHeight();
    const topHeaderHeight = $('.top-header').outerHeight();
    const generalMessageHeight = $('.generalmessage').outerHeight();

    if ($('body').hasClass('saffireWindowScrolled')) {
      $('header').css('top', -(topHeaderHeight + generalMessageHeight) + 'px');

      if ($('body').hasClass('homepage')) {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 'px',
        );
      } else {
        $('.content').css(
          'margin-top',
          headerHeight - (topHeaderHeight + generalMessageHeight) + 20 + 'px',
        );
      }
    } else {
      $('header').css('top', '0');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + 20 + 'px');
      }
    }
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      updateContentMargin();
      clearInterval(interval);
    }
  }, 300);

  $(window).on('scroll', function () {
    updateContentMargin();
  });
}
